export default __webpack_public_path__ + "static/weizmann-logo-8bf1deb699583590422623dea35fe160.jpeg";